import { Component, OnInit, ViewChild } from '@angular/core';
import { SobreBlancoService } from '../../services/sobre-blanco.service';
import { ObrasService } from '../../services/obras.service';
import { CuentasService } from '../../services/cuentas.service';
import { ErrorsService } from '../../services/tools/errors.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { SecurityModalComponent } from '../partials/security-modal/security-modal.component';

declare var $: any;

@Component({
  selector: 'app-sobre-blanco',
  templateUrl: './sobre-blanco.component.html',
  styleUrls: ['./sobre-blanco.component.scss']
})
export class SobreBlancoComponent implements OnInit {
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;

  // Saldos iniciales editables por tarjeta. Al saldo inicial se le suman/restan los movimientos
  // posteriores a la fecha de corte (la maneja el backend).
  public baseReembolso: number = 0;
  public baseOYV: number = 0;
  public baseInsurgentes: number = 0;
  public baseKR: number = 0;
  public baseOP: number = 0;
  public baseReforma: number = 0;

  public baseReembolsoEdit: number = 0;
  public baseOYVEdit: number = 0;
  public baseInsurgentesEdit: number = 0;
  public baseKREdit: number = 0;
  public baseOPEdit: number = 0;
  public baseReformaEdit: number = 0;

  public fechaCorte: string = '';
  public fechaImpresion: string = '';
  public showEditBases = false;
  public savingBases = false;

  // Saldos cargados del backend (única fuente: sobre_blanco_movimientos)
  public sobreSaldos: any = {};

  public totalkr = 0;
  public totaloyv = 0;
  public totalreforma = 0;
  public totalinsurgentes = 0;
  public totalop = 0;

  public totalingresosreembolso = 0;
  public totalegresosreembolso = 0;
  public totalingresocuenta = 0;
  public totalegresoreembolso = 0;

  public tiposMovimiento = [
    {id: 1, nombre: 'Ingreso a reembolso'},
    {id: 6, nombre: 'Egreso de reembolso'},
    {id: 2, nombre: 'Traspaso entre cuentas'},
    {id: 5, nombre: 'Ingreso a cuenta'}
  ];

  // Listado de capturas para revisar/corregir
  public movimientosCapturados: any[] = [];
  public loadingMovimientos = false;
  public eliminandoId: any = null;

  public obras: any[] = [];
  public obrasTraspaso: any[] = [];
  public obrasIngresoCuenta: any[] = [];
  public cuentas: any[] = [];

  private readonly OBRAS_TRASPASO_PERMITIDAS = [1, 11, 13, 17, 21];
  private readonly OBRAS_INGRESO_CUENTA_PERMITIDAS = [1, 11, 13, 17, 21];

  public movimiento: any = {};

  public securityActived = false;
  public loadingTotales = false;
  public loadingOYV = false;

  constructor(
    private sobreBlancoService: SobreBlancoService,
    private obrasService: ObrasService,
    private cuentasService: CuentasService,
    private errorService: ErrorsService,
    private authService: AutenticacionService,
    private helperService: HelpersService
  ) { }

  ngOnInit() {
    const hoy = new Date();
    const dd = ('0' + hoy.getDate()).slice(-2);
    const mm = ('0' + (hoy.getMonth() + 1)).slice(-2);
    this.fechaImpresion = dd + '/' + mm + '/' + hoy.getFullYear();
    this.obtenerObras();
    this.obtenerCuentas();
    this.actualizarTotales();
    this.cargarBasesYTotales();
    this.cargarMovimientos();
  }

  obtenerObras() {
    this.obrasService.getObratoSelect().subscribe(response => {
      this.obras = response.json().content;
      this.obrasTraspaso = (this.obras || []).filter(o => this.OBRAS_TRASPASO_PERMITIDAS.indexOf(parseInt(o.idObras)) !== -1);
      this.obrasIngresoCuenta = (this.obras || []).filter(o => this.OBRAS_INGRESO_CUENTA_PERMITIDAS.indexOf(parseInt(o.idObras)) !== -1);
    }, error => {
      console.log(error);
    });
  }

  obtenerCuentas() {
    this.cuentasService.getCuentastoSelect().subscribe(response => {
      this.cuentas = response.json().content;
    }, error => {
      console.log(error);
    });
  }

  actualizarTotales() {
    this.loadingTotales = true;
    this.sobreBlancoService.obtenerTotales().subscribe(response => {
      const data = response.json().data;
      this.totalingresosreembolso = data.total_ingresos || 0;
      this.totalegresosreembolso = data.total_traspasos || 0;
      this.totalingresocuenta = data.total_ingreso_cuenta || 0;
      this.totalegresoreembolso = data.total_egreso_reembolso || 0;
      this.loadingTotales = false;
    }, error => {
      console.log(error);
      this.loadingTotales = false;
    });
  }

  cargarBasesYTotales() {
    this.loadingOYV = true;
    this.sobreBlancoService.obtenerBases().subscribe(response => {
      const data = response.json().data || {};
      this.baseReembolso   = data['0']  || 0;
      this.baseOYV         = data['1']  || 0;
      this.baseInsurgentes = data['11'] || 0;
      this.baseKR          = data['13'] || 0;
      this.baseOP          = data['17'] || 0;
      this.baseReforma     = data['21'] || 0;
      this.cargarTotalesSobre();
    }, error => {
      console.log(error);
      this.loadingOYV = false;
    });
  }

  recalcularTotalesObra() {
    const sb = this.sobreSaldos;
    this.totaloyv         = sb['1']  || 0;
    this.totalinsurgentes = sb['11'] || 0;
    this.totalkr          = sb['13'] || 0;
    this.totalop          = sb['17'] || 0;
    this.totalreforma     = sb['21'] || 0;
  }

  getSaldoReembolso(): number {
    // total_egreso_reembolso (tipo 6) viene en negativo, por eso se suma.
    return this.baseReembolso + this.totalingresosreembolso + this.totalegresosreembolso
      - this.totalingresocuenta + this.totalegresoreembolso;
  }

  abrirEditBases() {
    this.baseReembolsoEdit   = this.baseReembolso;
    this.baseOYVEdit         = this.baseOYV;
    this.baseInsurgentesEdit = this.baseInsurgentes;
    this.baseKREdit          = this.baseKR;
    this.baseOPEdit          = this.baseOP;
    this.baseReformaEdit     = this.baseReforma;
    this.showEditBases = true;
  }

  cerrarEditBases() {
    this.showEditBases = false;
  }

  guardarBasesObra() {
    this.savingBases = true;
    const bases = {
      '0':  this.baseReembolsoEdit,
      '1':  this.baseOYVEdit,
      '11': this.baseInsurgentesEdit,
      '13': this.baseKREdit,
      '17': this.baseOPEdit,
      '21': this.baseReformaEdit,
    };
    this.sobreBlancoService.guardarBases(bases).subscribe(response => {
      this.baseReembolso   = this.baseReembolsoEdit;
      this.baseOYV         = this.baseOYVEdit;
      this.baseInsurgentes = this.baseInsurgentesEdit;
      this.baseKR          = this.baseKREdit;
      this.baseOP          = this.baseOPEdit;
      this.baseReforma     = this.baseReformaEdit;
      this.cargarTotalesSobre();
      this.showEditBases = false;
      this.savingBases = false;
      $.NotificationApp.send('Éxito', 'Saldos iniciales actualizados.', 'top-right', 'rgba(0,0,0,0.2)', 'success');
    }, error => {
      this.savingBases = false;
      $.NotificationApp.send('Error', 'No se pudieron guardar los saldos iniciales.', 'top-right', 'rgba(0,0,0,0.2)', 'error');
    });
  }

  getTotalGeneral(): number {
    return this.totalkr + this.totaloyv + this.totalreforma + this.totalinsurgentes + this.totalop + this.getSaldoReembolso();
  }

  guardarMovimiento() {
    if (!this.movimiento.tipoMovimiento) {
      $.NotificationApp.send('Advertencia', 'Falta seleccionar el Tipo de Movimiento.', 'top-right', 'rgba(0,0,0,0.2)', 'warning');
      return;
    }
    if (!this.movimiento.importe) {
      $.NotificationApp.send('Advertencia', 'Falta capturar el Importe.', 'top-right', 'rgba(0,0,0,0.2)', 'warning');
      return;
    }
    if (!this.movimiento.descripcion) {
      $.NotificationApp.send('Advertencia', 'Falta capturar la Descripción.', 'top-right', 'rgba(0,0,0,0.2)', 'warning');
      return;
    }

    if (this.movimiento.tipoMovimiento == 1) {
      if (!this.movimiento.porcentajeComision) {
        $.NotificationApp.send('Advertencia', 'Debes capturar el porcentaje de comisión.', 'top-right', 'rgba(0,0,0,0.2)', 'warning');
        return;
      }
    } else if (this.movimiento.tipoMovimiento == 2) {
      if (!this.movimiento.idObra) {
        $.NotificationApp.send('Advertencia', 'Debes seleccionar la obra para el traspaso.', 'top-right', 'rgba(0,0,0,0.2)', 'warning');
        return;
      }
    } else if (this.movimiento.tipoMovimiento == 5) {
      if (!this.movimiento.idObra) {
        $.NotificationApp.send('Advertencia', 'Debes seleccionar la obra para el ingreso a cuenta.', 'top-right', 'rgba(0,0,0,0.2)', 'warning');
        return;
      }
    }

    this.sobreBlancoService.guardarMovimiento(this.movimiento).subscribe(response => {
      this.movimiento = {};
      this.actualizarTotales();
      this.cargarTotalesSobre();
      this.cargarMovimientos();
      $.NotificationApp.send('Éxito', response.json().mensaje, 'top-right', 'rgba(0,0,0,0.2)', 'success');
    }, error => {
      let msg = 'No se pudo guardar el registro.';
      try { msg = error.json().mensaje || msg; } catch(e){}
      $.NotificationApp.send('Error', msg, 'top-right', 'rgba(0,0,0,0.2)', 'error');
    });
  }

  private formatMoney(v: number): string {
    const n = Number(v) || 0;
    const abs = Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (n < 0 ? '-$' : '$') + abs;
  }

  private buildResumenHtml(): string {
    const cajas = [
      ['KR',               this.totalkr],
      ['CONSTRUCTORA OYV', this.totaloyv],
      ['REEMBOLSO',        this.getSaldoReembolso()],
      ['FID. REFORMA',     this.totalreforma],
      ['INSURGENTES',      this.totalinsurgentes],
      ['OP PREMIER',       this.totalop],
    ];
    const cyan = '#00B0F0';
    const cellBorder = 'border:1px solid #000;';
    const titleStyle = `background:${cyan};color:#fff;font-weight:bold;text-align:center;padding:6px;${cellBorder}`;
    const labelStyle = `padding:6px;${cellBorder}`;
    const valueStyle = `padding:6px;text-align:right;font-weight:bold;${cellBorder}`;

    const gapCell = `<td class="cb-gap" style="border:none;padding:0;"><div style="width:34px;"></div></td>`;

    const renderFila = (inicio: number) => {
      let titulos = '';
      let filaTotalOYV = '';
      let filaTotal = '';
      for (let i = inicio; i < inicio + 3; i++) {
        const [nombre, total] = cajas[i] as [string, number];
        const monto = this.formatMoney(total as number);
        const sep = i > inicio ? gapCell : '';
        titulos       += `${sep}<td colspan="2" style="${titleStyle}">${nombre}</td>`;
        filaTotalOYV  += `${sep}<td style="${labelStyle}">Total O Y V</td><td style="${valueStyle}">${monto}</td>`;
        filaTotal     += `${sep}<td style="${labelStyle}">TOTAL</td><td style="${valueStyle}">${monto}</td>`;
      }
      return `<tr>${titulos}</tr><tr>${filaTotalOYV}</tr><tr>${filaTotal}</tr>`;
    };

    const totalGeneral = this.formatMoney(this.getTotalGeneral());
    return `
<table style="border-collapse:collapse;font-family:Arial,sans-serif;font-size:12px;">
  <tr><td colspan="8" style="${titleStyle}">RESUMEN EN CUENTAS</td></tr>
  ${renderFila(0)}
  <tr><td colspan="8" class="cb-gap" style="height:95px;border:none;"></td></tr>
  ${renderFila(3)}
  <tr><td colspan="8" class="cb-gap" style="height:45px;border:none;"></td></tr>
  <tr>
    <td colspan="6" style="border:none;"></td>
    <td colspan="2" style="padding:6px;text-align:center;text-decoration:underline;font-weight:bold;${cellBorder}">${totalGeneral}</td>
  </tr>
</table>`;
  }

  exportPDF() {
    const html = this.buildResumenHtml();
    const win = window.open('', '_blank');
    if (!win) { return; }
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
      'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const d = new Date();
    const fecha = `${d.getDate()} de ${meses[d.getMonth()]} de ${d.getFullYear()}`;
    const doc = `<!doctype html><html><head><meta charset="utf-8"><title>Reporte Carpeta Blanca</title>
<style>
  @page { size: letter landscape; margin: 12mm; }
  html, body { height: 100%; }
  body { font-family: Arial, sans-serif; margin: 0; }
  .cb-page { display: flex; flex-direction: column; align-items: center; }
  .cb-head { text-align: center; margin: 2mm 0 8mm; }
  .cb-head h1 { font-size: 26px; margin: 0 0 8px; letter-spacing: .5px; }
  .cb-head .cb-fecha { font-size: 16px; color: #222; }
  .cb-page table { margin: 0 auto !important; font-size: 17px !important; }
  .cb-page table td { padding: 12px 26px !important; font-size: 17px !important; }
  .cb-page table td.cb-gap { padding: 0 !important; }
</style></head><body>
  <div class="cb-page">
    <div class="cb-head">
      <h1>Resumen en Cuentas — Carpeta Blanca</h1>
      <div class="cb-fecha">Fecha: ${fecha}</div>
    </div>
    ${html}
  </div>
  <script>window.onload=function(){setTimeout(function(){window.print();},300);};<\/script>
</body></html>`;
    win.document.write(doc);
    win.document.close();
  }

  exportExcel() {
    const html = this.buildResumenHtml();
    const xls = `<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Resumen</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>${html}</body></html>`;
    const blob = new Blob(['\ufeff' + xls], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'Reporte_Carpeta_Blanca_' + new Date().toISOString().substring(0, 10) + '.xls';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => { link.remove(); }, 200);
  }

  canSecurity() {
    return this.sobreBlancoService.canSecurity();
  }

  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.securityActived = false;
            this.securityModal.push({
              'passwordActivated': false
            });
            this.actualizarTotales();
            this.recalcularTotalesObra();
          }
        });
    }
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.sobreBlancoService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if (respuesta.success === true) {
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
          this.actualizarTotales();
          this.recalcularTotalesObra();
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      });
  }

  cargarMovimientos() {
    this.loadingMovimientos = true;
    this.sobreBlancoService.obtenerMovimientos().subscribe(response => {
      this.movimientosCapturados = response.json().data || [];
      this.loadingMovimientos = false;
    }, error => {
      console.log(error);
      this.movimientosCapturados = [];
      this.loadingMovimientos = false;
    });
  }

  eliminarCaptura(m) {
    if (!m || !m.id) { return; }
    let aviso = '¿Eliminar esta captura?\n\n' + (m.tipo_nombre || '') + ' — $' + (Number(m.importe) || 0).toFixed(2) + '\n' + (m.descripcion || '');
    if (m.tipo_movimiento == 1) {
      aviso += '\n\nNota: al ser un Ingreso a reembolso, también se quitará la comisión que el sistema generó en CONSTRUCTORA OYV.';
    }
    if (!confirm(aviso)) { return; }
    this.eliminandoId = m.id;
    this.sobreBlancoService.eliminarMovimiento(m.id).subscribe(response => {
      this.eliminandoId = null;
      this.actualizarTotales();
      this.cargarTotalesSobre();
      this.cargarMovimientos();
      $.NotificationApp.send('Éxito', 'Captura eliminada.', 'top-right', 'rgba(0,0,0,0.2)', 'success');
    }, error => {
      this.eliminandoId = null;
      let msg = 'No se pudo eliminar la captura.';
      try { msg = error.json().mensaje || msg; } catch (e) {}
      $.NotificationApp.send('Error', msg, 'top-right', 'rgba(0,0,0,0.2)', 'error');
    });
  }

  cargarTotalesSobre() {
    this.loadingOYV = true;
    this.sobreBlancoService.obtenerTotalesObra().subscribe(response => {
      const data = response.json().data;
      this.sobreSaldos = data.sobre_blanco || {};
      this.fechaCorte = data.fecha_corte || '';
      this.recalcularTotalesObra();
      this.loadingOYV = false;
    }, error => {
      console.log(error);
      this.loadingOYV = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/sobre-blanco/sobre-blanco.component.ts